import { WatchQueryFetchPolicy } from "apollo-client";
import { integrationConfig } from "./integrationConfig";

export const mainApiConfig = {
    endpoint: `${integrationConfig.apiServer}graphql`,
    defaultFetchPolicy: 'cache-and-network' as WatchQueryFetchPolicy,
    //defaultFetchPolicy: 'cache-first' as WatchQueryFetchPolicy,
};